import { PERMISSIONS } from '@conversed/shared/src/central/constants/permissions';
import { AIPerformanceScoresSchema } from '@conversed/shared/src/central/types/ai-performance';
import { createRESTContract } from '../../index';

export const aiPerformanceContract = createRESTContract({
  getAIPerformanceScores: {
    method: 'GET',
    path: '/ai-performance/scores',
    permissions: [PERMISSIONS.TEST_ACCURACY.TEST_ACCURACY_EDIT],
    response: AIPerformanceScoresSchema,
  },
});
